const grid = {
  gutters: {
    small: 20,
    medium: 30,
  },
};

export default grid;
